import React from 'react'

export const ResumeEducation = (props) => {
  return (
    <div className="education-container">
        <h4>{props.course}</h4>
        <h4 className="school">{props.school}</h4>
        <p>{props.location}</p>
        <p><i>{props.sy}</i></p>
    </div>
  )
}
